class VariantRadiosKits extends VariantSelects {
  constructor() {
    super();

    this.kitCard = this.closest('.kit-card');
    this.dataset.updateSwatch = true;
  }

  async onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    this.removeErrorMessage();

    if (this.dataset.updateVariantTitle) {
      let variantTitle = this.querySelector('.quickbuy-form__variant-title');
      variantTitle.innerHTML = this.currentVariant.title.replaceAll(' / Regular', '').replaceAll(' / Bundle Item', '').replaceAll(' / Bundle', '');
    }

    if (this.dataset.updateSwatch) {
      this.updateColorSwatch();
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();

      this.productCardResponse = await this.fetchProductCard();
      this.updateMedia();
      this.renderProductInfo();

      this.updateShareUrl();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    let isBundle = this.getVariantData()[0].options.indexOf('Regular') > -1 ? true : false; // Check first variant if contains 'Regular' type option
    this.currentVariant = this.getVariantData().find((variant) => {
      if (isBundle && variant.title.includes('Regular')) return false;
      return isBundle
        ? variant.options[0] === this.options[0]
        : !variant.options.map((option, index) => { return this.options[index] === option; }).includes(false);
    });
  }

  updateVariantInput() {
    // get ID from kit-card and update the corresponding product form input
    let inputID = String(this.id);
    const kitForm = document.querySelector('product-form-kit form');
    let lineItemProp = kitForm.querySelector(`input[id=${inputID}]`)

    lineItemProp.value = this.currentVariant.id;
  }

  async fetchProductCard() {
    const response = await fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=kit-card`);
    const responseText = await response.text();
    return responseText;
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media || !this.kitCard) return;

    const cardImg = this.kitCard.querySelector('.kit-card__image img');
    cardImg.classList.add('loading');
    setTimeout(() => {
      cardImg.src = this.currentVariant.featured_media.preview_image.src;
      cardImg.classList.remove('loading')
    }, 300);
  }

  renderProductInfo() {
    // Product url and title
    if (!this.kitCard) return;
    const html = new DOMParser().parseFromString(this.productCardResponse, 'text/html');
    const destination = [this.kitCard.querySelector('.kit-card__info .subheading'), this.kitCard.querySelector('.kit-card__info .kit-card-subtext')];
    const sources = [html.querySelector('.kit-card__info .subheading'), html.querySelector('.kit-card__info .kit-card-subtext')];

    destination.forEach((dest, index) => {
      let source = sources[index];
      if (destination && source) dest.innerHTML = source.innerHTML;
    });
  }

  updateColorSwatch() {
    let inputs = document.querySelectorAll('variant-radios-kits input')
    inputs.forEach((el) => {
      let current_title = this.currentVariant.title.replaceAll(' / Regular', '').replaceAll(' / Bundle Item', '').replaceAll(' / Bundle', '');
      if (el.value == current_title) {
        let elSwatch = el.getAttribute('data-swatch')
        document.documentElement.style.setProperty('--accent-swatch', elSwatch)

        let ctaTextColor = el.getAttribute('data-text-color')
        document.documentElement.style.setProperty('--cta-text', ctaTextColor)

        let variantTitle = el.getAttribute('data-title')
        let variantSubtitle = el.getAttribute('data-subtitle')

        let titleContainer = this.nextElementSibling
        titleContainer.querySelector('span').innerHTML = variantTitle
        titleContainer.querySelector('em').innerHTML = variantSubtitle
      }
    });
  }
}

customElements.define('variant-radios-kits', VariantRadiosKits);
